import { mdbContainer, mdbRow, mdbCol, mdbCardBody, mdbCard } from "mdbvue";
import { mapActions } from "vuex";
import Btn from "../../../../core/Button";
import Popup from "../../../../core/Popup";
import Swal from "sweetalert2";
import { email, required } from "vuelidate/lib/validators";
import ValidationError from "../../../misc/ValidationError";
import Loader from "../../../../core/Loader";
import Paginator from "../../../../core/Paginator.vue"
const Seller = {
    name: "Seller",
    components: {
        Loader,
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCardBody,
        mdbCard,
        Btn,
        Popup,
        ValidationError,
        Paginator
    },
    data() {
        return {
            search: '',
            isLoading: true,
            totalOfElements: 0,
            page: 1,
            perPage: 10,
            numberOfPages: 0,
            dataList: [],
            classPop: "popup__header-admin",
            isEdit: false,
            sellerId: "",
            sellerName: "",
            sellerLastName: "",
            sellerMothersLastName: "",
            sellerEmail:"",
            columns: [
                {
                  label: 'Nombre completo',
                  key: 'name',
                  sort: false,
                  class: 'text-left',
                  thStyle: {
                    "font-size": "1.6rem",
                    "padding": "1.0rem 0.5rem",
                    "background-color": "#3a8a65",
                    "color": "#fff",
                    "border-top-left-radius": "5px",
                    "border-bottom-left-radius": "5px"
                  },
                  tdClass: "tableCol-start",
                  tdStyle: {
                    "font-size": "1.6rem",
                  }
                },
              
                
               
                {
                  label: '',
                  key: 'options',
                  sort: false,
                  class: 'text-rigth',
                  thStyle: {
                    "font-size": "1.6rem",
                    "padding": "1.0rem 2.5rem",
                    "background-color": "#3a8a65",
                    "color": "#fff",
                    "border-top-right-radius": "5px",
                    "border-bottom-right-radius": "5px"
                  },
                  tdClass: "tableCol-end",
                  tdStyle: {
                    "font-size": "1.6rem",
                  }
                },
              ],
        };
    },
    validations: {
        sellerName: {
            required
        },
        sellerLastName: {
            required
        },
        sellerMaidenName: {

        },
        sellerEmail:{
            required
        }
    },
    methods: {
        ...mapActions([
            "_createSeller",
            "_updateSeller",
            "_deleteSeller",
            "_getSellers",
        ]),
        cleanData() {
            this.totalOfElements = 0;
            this.page = 1;
            this.perPage = 10;
            this.search = '';
            this.pages = [];
            this.numberOfPages = 0;
            this.dataList = [];
        },
        async getSellers() {
            try {
                this.isLoading = true;
                const params = {
                    pageSize: this.perPage,
                    pageNumber: this.page - 1,
                    name: this.search
                };
                const { data } = await this._getSellers(params);
                if (data.status === 200) {
                    const { data: sellers, totalElements, totalPages } = data;
                    this.numberOfPages = totalPages;
                    this.totalOfElements = totalElements;
                    this.dataList = sellers;
                }else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.status === 404) {
                    this.dataList = [];
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        async deleteSeller(){
            try {
                this.closeModal('delete');
                this.isLoading = true;
                const { data } = await this._deleteSeller({
                    sellerId: this.sellerId
                });
                if (data.status === 200) {
                    this.cleanData();
                    this.getSellers();
                    this.alertSuccess(
                        'ELIMINACIÓN CORRECTA',
                        'Vendedor eliminado correctamente.'
                    );
                }else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                this.pushNotifyError();
            }
            finally {
                this.isLoading = false;
            }
        },
        async createSeller() {
            try {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.closeModal('persist');
                this.isLoading = true;
                const body = {
                    name: this.sellerName,
                    lastName: this.sellerLastName,
                    mothersLastName: this.sellerMothersLastName,
                    email:this.sellerEmail
                };
                const { data } = await this._createSeller(body);
                if (data.status === 201) {
                    this.cleanData();
                    this.getSellers();
                    this.alertSuccess(
                        'REGISTRO CORRECTO',
                        'Registro de vendedor realizado correctamente.'
                    );
                }
                else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.data &&  error.response.data.errorDetails) {
                    this.pushNotifyError(error.response.data.errorDetails);
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        async updateSeller() {
            try {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.closeModal('persist');
                this.isLoading = true;
                const params = {
                    sellerId: this.sellerId,
                    body: {
                        name: this.sellerName,
                        lastName: this.sellerLastName,
                        mothersLastName: this.sellerMothersLastName,
                        email:this.sellerEmail
                    }
                };

                const { data } = await this._updateSeller(params);
                if (data.status === 200) {
                    this.cleanData();
                    this.getSellers();
                    this.alertSuccess(
                        'EDICIÓN CORRECTA',
                        'Edición de vendedor realizada correctamente.'
                    );
                }else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.data &&  error.response.data.errorDetails) {
                    this.pushNotifyError(error.response.data.errorDetails);
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        closeModal(modal) {
            this.isEdit = false;
            if (modal === 'delete'){
                this.$refs.deleteSellerModal.toggleModal();
            } else {
                this.$refs.persistSellerModal.toggleModal();
            }
        },
        openCreateSellerModal(){
            this.isEdit = false;
            this.sellerId = "";
            this.sellerName = "";
            this.sellerLastName = "";
            this.sellerMothersLastName = "";
            this.sellerEmail = "";
            this.$refs.persistSellerModal.toggleModal();
        },
        openEditSellerModal({id, name, lastName, mothersLastName, email}) {
            this.isEdit = true;
            this.sellerId = id;
            this.sellerName = name;
            this.sellerLastName = lastName;
            this.sellerMothersLastName = mothersLastName;
            this.sellerEmail = email
            this.$refs.persistSellerModal.toggleModal();
        },
        confirmSellerDelete(id){
            this.sellerId = id;
            this.$refs.deleteSellerModal.toggleModal();
        },
        pushNotifyError(message = "Ha ocurrido un error, inténtalo más tarde."){
            this.$notify.error({
                message,
                position: "top right",
                timeOut: 15000
            });
        },
        alertSuccess(title, message) {
            Swal.fire({
                title:
                    `<span style='font-family: Josefin Sans,serif; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;' >${title} </span>`,
                html:
                    "<div>" +
                    `<span class='mt-4'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'>${message}</span>` +
                    "<br>"+
                    "<img alt='success_icon' src='/img/icons/ok.svg' style='width: 40%; margin-top: 3rem;' />" +
                    "</div>",
                width: "50rem",
                padding: "4rem",
                showConfirmButton: false,
                showCloseButton: true
            });
        },
        changePage(value) {
            this.page = value
        },
        changePerPage(value) {
            this.perPage = value
        },
    },
    mounted() {
        this.cleanData();
        this.getSellers();
    },
    watch: {
        search(){
            this.getSellers();
        },
        page(){
            this.getSellers();
        },
        perPage(){
            this.getSellers();
        }
    },
};

export default Seller;